const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${Math.round(kb * 100) / 100} KB`;
  }

  const mb = kb / 1024;
  return `${Math.round(mb * 100) / 100} MB`;
};

const convertFileToFormData = (file) => {
  const formData = new FormData();
  formData.append("source", file.originFileObj || file);
  return formData;
};

const formatCurrency = (value, currency = "BRL") => {
  const numericValue =
    typeof value === "string" ? Number(value.replace(",", ".")) : value;

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency,
  }).format(numericValue);
};

export { convertFileToFormData, formatFileSize, formatCurrency };
